import { z } from 'zod';
import type { TripStopType } from 'contracts/transport-routes';

const DEFAULT_MESSAGE = 'Obrigatório';

export const formSchema = z.object({
  type: z.custom<TripStopType>().default('city'),
  uf: z.string().optional(),
  ibge: z.string().optional(),
  latitude: z.string().optional(),
  longitude: z.string().optional(),
}).superRefine((formData, ctx) => {
  const { type, uf, ibge, latitude, longitude } = formData;

  if (type === 'city' && !uf) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: DEFAULT_MESSAGE,
      path: ['uf'],
    });
  }

  if (type === 'city' && !ibge) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: DEFAULT_MESSAGE,
      path: ['ibge'],
    });
  }

  if (type === 'coordinates' && !latitude) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: DEFAULT_MESSAGE,
      path: ['latitude'],
    });
  }

  if (type === 'coordinates' && !longitude) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: DEFAULT_MESSAGE,
      path: ['longitude'],
    });
  }
});

export type FormSchema = z.infer<typeof formSchema>;